<template>
  <div>
    <UserAccountContainer
      :user="user"
      :plan="getActiveUserPlan"
      :sub="getActiveUserSubscription"
      :forClient="true"
      :isAdmin="isAdmin"
      :loadingMessages="loadingMessages"
      :loadingSubscriptions="loadingSubscriptions"
      v-on:reloadPage="loadPage"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserAccountContainer from '../../components/UserAccount/UserAccountContainer.vue'

export default {
  name: 'AccountMgmt',
  components: { UserAccountContainer },
  data() {
    return {
      user: {},
      edit: false,
      loadingMessages: false,
      loadingSubscriptions: false
    }
  },
  computed: {
    ...mapGetters(['getMyInfo', 'getClientInfo', 'getActiveUserPlan', 'getActiveUserSubscription', 'getMessages']),
    isAdmin() {
      if (this.getMyInfo) return this.getMyInfo.hasRoles
    }
  },
  methods: {
    ...mapActions(['getClient', 'loadActiveUserSubscriptions', 'loadMessages', 'resetUserSubscriptions']),
    loadPage: async function () {
      this.loadingSubscriptions = true
      if (!this.isAdmin) this.loadingMessages = true
      this.resetUserSubscriptions()
      await this.getClient()
      this.user = this.getClientInfo
      if (!this.isAdmin) {
        await this.loadMessages()
        this.loadingMessages = false
      }
      this.user.message = this.getMessages.find(m => m.client && m.client._id === this.getClientInfo._id)
      await this.loadActiveUserSubscriptions(this.getClientInfo._id)
      this.loadingSubscriptions = false
    }
  },
  mounted: async function() {
    await this.loadPage()
  },
  watch: {
    getClientInfo(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.user = this.getClientInfo
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/UserMgmt/UserAccountMgmt.vue?13dd871a